import { useEffect, useState } from 'react';

import { useQuery } from '@zenbusiness/application-commons-graphql';

import { TOKEN_TYPES } from '#client/constants/tokens';
import { useLogError } from '#client/hooks/useLogError';
import { GET_COUNTERPARTY_BALANCE } from '#client/queries';

import useCustomerToken from './useCustomerToken';

export default function useCounterpartyBalance(id) {
  const [balances, setBalances] = useState({});
  const {
    customerToken,
    loading: customerTokenLoading,
    error: customerTokenError
  } = useCustomerToken({
    type: TOKEN_TYPES.COMMON,
    prefetch: true
  });

  const {
    error,
    errors,
    loading,
    data,
    refetch: refetchCounterpartyBalance
  } = useQuery(GET_COUNTERPARTY_BALANCE, {
    variables: {
      filter: {
        counterpartyId: id,
        customerToken
      }
    },
    skip: !id || balances[id] || !customerToken || customerTokenLoading,
    noThrow: true,
    skipCache: true
  });

  useLogError(errors, error);
  /**
   * Cache the balances for each unit account id
   */
  useEffect(() => {
    const counterpartyBalance = data?.bankingCounterpartyBalance;
    if (counterpartyBalance && !balances[id]) {
      setBalances({ ...balances, [id]: counterpartyBalance });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return {
    data,
    counterpartyBalance: balances[id],
    error: error || customerTokenError,
    loading: loading || customerTokenLoading,
    refetchCounterpartyBalance
  };
}
